import * as Types from '../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddJobSeekerProfileResumeFileMutationVariables = Types.Exact<{
  input: Types.AddJobSeekerProfileResumeFileInput;
}>;


export type AddJobSeekerProfileResumeFileMutation = { __typename?: 'Mutation', addJobSeekerProfileResumeFile?: { __typename?: 'AddJobSeekerProfileResumeFilePayload', pdfResumeFile?: { __typename?: 'JobSeekerProfileFile', id: string, fileType?: Types.JobSeekerProfileFileType | null } | null, originalResumeFile?: { __typename?: 'JobSeekerProfileFile', id: string, tags: Array<string> } | null, jobSeekerProfileResume?: { __typename?: 'JobSeekerProfileResume', id: string } | null } | null };


export const AddJobSeekerProfileResumeFileDocument = gql`
    mutation AddJobSeekerProfileResumeFile($input: AddJobSeekerProfileResumeFileInput!) {
  addJobSeekerProfileResumeFile(input: $input) {
    pdfResumeFile {
      id
      fileType
    }
    originalResumeFile {
      id
      tags
    }
    jobSeekerProfileResume {
      id
    }
  }
}
    `;
export type AddJobSeekerProfileResumeFileMutationFn = Apollo.MutationFunction<AddJobSeekerProfileResumeFileMutation, AddJobSeekerProfileResumeFileMutationVariables>;

/**
 * __useAddJobSeekerProfileResumeFileMutation__
 *
 * To run a mutation, you first call `useAddJobSeekerProfileResumeFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddJobSeekerProfileResumeFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addJobSeekerProfileResumeFileMutation, { data, loading, error }] = useAddJobSeekerProfileResumeFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddJobSeekerProfileResumeFileMutation(baseOptions?: Apollo.MutationHookOptions<AddJobSeekerProfileResumeFileMutation, AddJobSeekerProfileResumeFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddJobSeekerProfileResumeFileMutation, AddJobSeekerProfileResumeFileMutationVariables>(AddJobSeekerProfileResumeFileDocument, options);
      }
export type AddJobSeekerProfileResumeFileMutationHookResult = ReturnType<typeof useAddJobSeekerProfileResumeFileMutation>;
export type AddJobSeekerProfileResumeFileMutationResult = Apollo.MutationResult<AddJobSeekerProfileResumeFileMutation>;
export type AddJobSeekerProfileResumeFileMutationOptions = Apollo.BaseMutationOptions<AddJobSeekerProfileResumeFileMutation, AddJobSeekerProfileResumeFileMutationVariables>;